// extracted by mini-css-extract-plugin
module.exports = {"FILTER":"Filter_FILTER__1w6SE"};